import { Component } from '@angular/core';
import { NotificationMessage, NotificationType } from 'src/openapi-gen/models';
import { AppConfig } from 'src/app/core/config/config';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-toast-component',
    template: `
    <p-toast [key]="NOTIFICATION_TOAST_KEY" position="bottom-center"></p-toast>
    <p-toast [key]="NOTIFICATION_CONFIRM_KEY" position="bottom-center" (onClose)="onReject()" [baseZIndex]="5000">
      <ng-template let-message pTemplate="message">
        <div>
          <div class="text-center">
              <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
              <h4>{{message.summary}}</h4>
              <p>{{message.detail}}</p>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-raised-button style="width: 100%" type="button" color="primary" (click)="onConfirm()">{{confirmLabel}}</button>
            <span>&nbsp;</span>
            <button mat-raised-button style="width: 100%" type="button" color="warn" (click)="onReject()">{{cancelLabel}}</button>
          </div>
        </div>
      </ng-template>
    </p-toast>
  `,
    styles: [],
    standalone: true,
    imports: [ToastModule, FlexModule, MatButtonModule]
})
export class ToastComponent {
  private COMPONENT_GUID: string;

  get NOTIFICATION_TOAST_KEY(): string {
    return `notification-toast-${this.COMPONENT_GUID}`;
  }

  get NOTIFICATION_CONFIRM_KEY(): string {
      return `confirm-toast-${this.COMPONENT_GUID}`;
  }

  private toastDuration: number;
  private confirmFunction: Function;
  private rejectFunction: Function;

  confirmLabel: string;
  cancelLabel: string;

  constructor(
    private appConfig: AppConfig,
    private messageService: MessageService
  ) {
    this.COMPONENT_GUID = crypto.randomUUID();
    this.toastDuration = this.appConfig.setting['SnackBarDuartion'];
  }

  public showToast(notification: NotificationMessage) {
    this.show(notification.action, notification.message);
  }

  public showBasicErrorToast() {
    this.show(NotificationType.Error, "Something went wrong!");
  }

  private show(type: NotificationType, message: string, sticky: boolean = false): void {
    switch(type) {
        case NotificationType.Success:
            this.messageService.add({ key: this.NOTIFICATION_TOAST_KEY, severity:'success', summary: 'Success', detail: message, sticky: sticky, life: this.toastDuration});
            break;
        case NotificationType.Information:
            this.messageService.add({ key: this.NOTIFICATION_TOAST_KEY, severity:'info', summary: 'Info', detail: message, sticky: sticky, life: this.toastDuration});
            break;
        case NotificationType.Warning:
            this.messageService.add({ key: this.NOTIFICATION_TOAST_KEY, severity:'warn', summary: 'Warning', detail: message, sticky: sticky, life: this.toastDuration});
            break;
        case NotificationType.Error:
            this.messageService.add({ key: this.NOTIFICATION_TOAST_KEY, severity:'error', summary: 'Error', detail: message, sticky: sticky, life: this.toastDuration});
            break;
    }
  }

  showConfirm(
    summary: string, 
    detail: string,
    onConfirm: Function,
    onReject: Function,
    confirmLabel = 'Yes',
    cancelLabel = 'No'
  ) {
      this.confirmFunction = onConfirm;
      this.rejectFunction = onReject;

      this.confirmLabel = confirmLabel;
      this.cancelLabel = cancelLabel;

      this.messageService.clear(this.NOTIFICATION_CONFIRM_KEY);
      this.messageService.add({
          key: this.NOTIFICATION_CONFIRM_KEY, 
          sticky: true, 
          severity:'warn', 
          summary: summary, 
          detail: detail
      });
  }

  clearToasts() {
    this.messageService.clear();
  }

  clearMessages() {
      this.messageService.clear(this.NOTIFICATION_CONFIRM_KEY);
  }

  protected getToastIcon(severity: string) {
    switch(severity) {
      case 'success':
        return 'pi pi-check';
      case 'info':
        return 'pi pi-info-circle';
      case 'warn':
        return 'pi pi-exclamation-triangle';
      case 'error':
        return 'pi pi-times';
      default:
        return 'pi pi-info-circle';
    }
  }

  protected onConfirm() {
      this.messageService.clear(this.NOTIFICATION_CONFIRM_KEY);
      this.confirmFunction();
  }

  protected onReject() {
      this.messageService.clear(this.NOTIFICATION_CONFIRM_KEY);
      this.rejectFunction();
  }
}
